module.exports = __webpack_public_path__ + "static/img/pic_VIPYS_01@2x.97f4396c.png";